import { render, staticRenderFns } from "./VFlagName.vue?vue&type=template&id=c571bdfa&"
import script from "./VFlagName.vue?vue&type=script&lang=js&"
export * from "./VFlagName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports